import app from 'flarum/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Tooltip from 'flarum/common/components/Tooltip';
import classList from "flarum/common/utils/classList";

export default class UploadButton extends Component {
    oninit(vnode) {
        super.oninit(vnode);
        console.log('oninit')
        this.isLoading = false;
        this.isSuccess = false;
        this.isError = false;
        this.isPasteListenerAttached = false;
        this.boundPaste = null
    }

    oncreate(vnode) {
        console.log('oncreate')
        super.oncreate(vnode);
        // 获取整个编辑器的DOM元素
        this.editorContainer = this.$().closest('.ComposerBody-editor').get(0);

        // 监听整个编辑器的拖拽事件
        this.editorContainer.addEventListener('dragover', this.handleDragOver.bind(this));
        this.editorContainer.addEventListener('drop', this.handleDrop.bind(this));
        this.editorContainer.addEventListener('dragleave', this.handleDragLeave.bind(this));
    }

    onupdate(vnode) {
        super.onupdate(vnode);
        if (!this.isPasteListenerAttached && app.forum.attribute('imgur-upload.allow-paste') === '1') {
            this.isPasteListenerAttached = true;
            this.boundPaste = this.paste.bind(this);
            this.attrs.textArea.addEventListener('paste', this.boundPaste);
        }
    }


    /**
     * 组件销毁时的回调函数
     * 需要在这里删除前面添加的paste监听器
     * 否则可能存在多个监听器，导致同一张图片多次上传
     * @param vnode
     */
    onremove(vnode) {
        super.onremove(vnode)
        this.attrs.textArea.removeEventListener('paste', this.boundPaste)
    }


    view() {
        let buttonIcon;
        if (this.isSuccess) buttonIcon = 'fas fa-check green';
        else if (this.isError) buttonIcon = 'fas fa-times red';
        else if (!this.isLoading) buttonIcon = 'far fa-image';

        let label = '';
        if (this.isLoading) label = app.translator.trans('imgur-upload.forum.loading');
        else if (this.isSuccess) label = app.translator.trans('imgur-upload.forum.done');
        else if (this.isError) label = app.translator.trans('imgur-upload.forum.error');

        return <Tooltip text={app.translator.trans('imgur-upload.forum.upload')}>
            <Button
                className={classList([
                    'Button',
                    'hasIcon',
                    'imgur-upload-button',
                    label === '' && 'Button--icon',
                ])}
                icon={buttonIcon}
                onclick={this.buttonClicked.bind(this)}>
                {this.isLoading && <LoadingIndicator size="small" display="inline"/>}
                <span className="Button-label">{label}</span>
                <form>
                    <input type="file" accept="image/*" onchange={this.formUpload.bind(this)}
                           disabled={this.isLoading || this.isSuccess || this.isError}/>
                </form>
            </Button>
        </Tooltip>
    }

    // 添加拖拽事件处理器
    handleDragOver(e) {
        e.preventDefault();
        this.editorContainer.classList.add('drag-over');
    }

    handleDrop(e) {
        e.preventDefault();
        this.editorContainer.classList.remove('drag-over');


        if (this.isLoading) return;
        if (e.dataTransfer && e.dataTransfer.files) {
            const file = e.dataTransfer.files[0];
            this.upload(file);
        }
    }

    handleDragLeave(e) {
        e.preventDefault();
        this.editorContainer.classList.remove('drag-over');
    }

    paste(e) {
        if (this.isLoading) return;
        if (e.clipboardData && e.clipboardData.items) {
            let item = e.clipboardData.items[0];
            console.log(item)
            if (!item.type.startsWith('image')) {
                return;
            }
            let file = item.getAsFile();
            this.upload(file);
        }
    }

    buttonClicked(e) {
        this.$('input').click();
    }

    formUpload(e) {
        const files = this.$('input').prop('files');
        if (files.length === 0) {
            return;
        }
        this.upload(files[0]);
    }

    upload(file) {
        this.isLoading = true;
        m.redraw();
        const formData = new FormData();
        formData.append('file', file);
        formData.append('album_id', app.forum.attribute('imgur-upload.album-id'));
        $.ajax({
            url: 'https://img.jdysya.top/api/v1/upload',
            headers: {
                'Authorization': app.forum.attribute('imgur-upload.client-id')
            },
            type: 'POST',
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            success: this.success.bind(this),
            error: this.error.bind(this)
        });
    }

    success(response) {
        this.$('input').val('');

        this.isLoading = false;
        this.isSuccess = true;
        m.redraw();

        let stringToInject = this.buildMdCode(response.data.links, response.data.width > 1024);

        this.attrs.editor.insertAtCursor(stringToInject);

        // After a bit, re-enable upload
        setTimeout(() => {
            this.isSuccess = false;
            m.redraw();
        }, 2000);
    }

    buildEmbedCode(imageUrl, isLarge) {
        let previewUrl = (isLarge ? this.previewUrl(imageUrl) : imageUrl);
        let embedType = app.forum.attribute('imgur-upload.embed-type');

        if (embedType === 'full-with-link') {
            return `[URL=${imageUrl}][IMG]${imageUrl}[/IMG][/URL]\n`;
        } else if (embedType === 'full-without-link') {
            return `[IMG]${imageUrl}[/IMG]\n`;
        } else if (embedType === 'preview-without-link') {
            return `[IMG]${previewUrl}[/IMG]\n`;
        } else {
            // Preview with link (default case)
            return `[URL=${imageUrl}][IMG]${previewUrl}[/IMG][/URL]\n`;
        }
    }

    /**
     * 这里修改后我需要的图片链接格式是markdown形式的
     * @param {*} imageUrl
     * @param {*} isLarge
     * @returns
     */
    buildMdCode(imageUrl, isLarge) {
        // let previewUrl = (isLarge ? this.previewUrl(imageUrl) : imageUrl);
        let album_id = app.forum.attribute('imgur-upload.album-id');
        console.log(`相册id为${album_id}`);
        return imageUrl['markdown']
        // if (embedType === 'full-with-link') {
        //     return `[URL=${imageUrl}][IMG]${imageUrl}[/IMG][/URL]\n`;
        // } else if (embedType === 'full-without-link') {
        //     return `[IMG]${imageUrl}[/IMG]\n`;
        // } else if (embedType === 'preview-without-link') {
        //     return `[IMG]${previewUrl}[/IMG]\n`;
        // } else {
        //     // Preview with link (default case)
        //     return `[URL=${imageUrl}][IMG]${previewUrl}[/IMG][/URL]\n`;
        // }
    }

    previewUrl(url) {
        let extensionIndex = url.lastIndexOf('.');
        return url.slice(0, extensionIndex) + 'h' + url.slice(extensionIndex);
    }

    error(response) {
        $('#imgur-upload-form').val('');

        this.isLoading = false;
        this.isError = true;
        m.redraw();

        // Output the error to the console, for debugging purposes
        console.error(response);

        // After a bit, re-enable upload
        setTimeout(() => {
            this.isError = false;
            m.redraw();
        }, 2000);
    }
}
